import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Col from 'component/utils/Col'
import Mask from 'vanilla-masker'
import OccurrenceCode8Modal from 'component/report/occurrencescode8/OccurrencesCode8Modal'
import { CODE8_TYPE } from 'constants/config'

class OlderOccurrencesCode8 extends Component {
  constructor(props) {
    super(props)

    const { translate } = props

    this.state = {
      toogleModal: false,
      icon: '',
      titleText: '',
      value: 0,
      valueComplement: '',
      subtitle: '',
      titleList: '',
      listSections: [],
      typeContent: 0,
      currency: translate('option.currency'),
      sizeCurrency: translate('size.currency'),
      formatCurrency: {
        separator: translate('separator.currency'),
        delimiter: translate('delimiter.currency'),
      },
    }

    this.handleModal = this.handleModal.bind(this)
    this.renderModal = this.renderModal.bind(this)
    this.toogleModal = this.toogleModal.bind(this)
  }

  toogleModal() {
    this.setState({ toogleModal: !this.state.toogleModal })
  }

  handleModal(typeCode8Occurrence) {
    const { translate, filters, code8Occurrences } = this.props

    const { toogleModal } = this.state

    /* istanbul ignore else */
    if (toogleModal) {
      this.setState({ toogleModal: false })
    }

    let state = {
      valueComplement: '',
      toogleModal: true,
    }

    switch (typeCode8Occurrence) {
      case CODE8_TYPE.LMS:
        state = {
          ...state,
          titleText: translate('occurrences-code8.sectionTitle'),
          subText:
            filters.dtStart || filters.dtEnd
              ? `${filters.dtStart} - ${filters.dtEnd}`
              : '',
          value: code8Occurrences.totalSections,
          subtitle: translate('occurrences-code8.sectionText'),
          titleList: translate('occurrences-code8.sectionModalText'),
          listSections: code8Occurrences.detailsSections,
          typeContent: CODE8_TYPE.LMS,
        }
        break
      case CODE8_TYPE.SALES:
        state = {
          ...state,
          titleText: translate('occurrences-code8.lossSaleTitle'),
          subText:
            filters.dtStart || filters.dtEnd
              ? `${filters.dtStart} - ${filters.dtEnd}`
              : '',
          value:
            this.state.currency +
            Mask.toMoney(
              code8Occurrences.totalLossRevenue
                ? code8Occurrences.totalLossRevenue.toFixed(
                    this.state.sizeCurrency
                  )
                : 0,
              this.state.formatCurrency
            ),
          subtitle: translate('occurrences-code8.lossSaleText'),
          titleList: translate('occurrences-code8.lossSaleModalText'),
          listSections: code8Occurrences.detailsLossRevenue,
          typeContent: CODE8_TYPE.SALES,
        }
        break
      default:
        break
    }

    this.setState(state)
  }

  renderModal() {
    const { translate } = this.props

    const {
      toogleModal,
      titleText,
      subText,
      value,
      subtitle,
      titleList,
      listSections,
      typeContent,
    } = this.state

    /* istanbul ignore else */
    if (!toogleModal) {
      return
    }

    const props = {
      translate,
      closeModal: this.toogleModal,
      titleText,
      subText,
      value,
      subtitle,
      titleList,
      listSections,
      typeContent,
    }

    return <OccurrenceCode8Modal {...props} />
  }

  render() {
    const { translate, code8Occurrences, filters, getCsv, getCsvRecurrence } =
      this.props

    return (
      <div className='code8-ocurrences-page container-mobile'>
        <div className='margin-left-double margin-right-double'>
          <Col xs={12} className='margin-bottom-double padding-bottom-double'>
            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='magnifier' />
                </div>

                <h4 className='heading-4 uppercase title'>
                  {translate('occurrences-code8.totalTitle')}
                </h4>
                <div>
                  <Col md={6}>
                    <span className='item-title'>
                      {translate('occurrences-code8.totalTitle')}
                    </span>
                    <br />
                    <span className='highlighted-number'>
                      {code8Occurrences.totalOccurrences}
                    </span>
                  </Col>
                  <Col md={6}>
                    <span className='item-title'>
                      {translate('occurrences-code8.totalTreatedTitle')}
                    </span>
                    <br />
                    <span className='highlighted-number'>
                      {code8Occurrences.totalTreatedOccurrences}
                    </span>
                  </Col>
                  <span className='subtext'>
                    {filters.dtStart || filters.dtEnd
                      ? `${filters.dtStart} - ${filters.dtEnd}`
                      : ''}
                  </span>
                </div>
                <p className='text'>
                  {translate('occurrences-code8.totalText')}
                </p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='clock' />
                </div>

                <div className='circular wrap-click' onClick={getCsvRecurrence}>
                  <i className='download' />
                </div>

                <h4 className='heading-4 uppercase title'>
                  {translate('occurrences-code8.clockTitle')}
                </h4>
                <div>
                  <span className='highlighted-number'>
                    {code8Occurrences.totalRecurrences}
                  </span>
                  <br />
                  <span className='subtext'>
                    {filters.dtStart || filters.dtEnd
                      ? `${filters.dtStart} - ${filters.dtEnd}`
                      : ''}
                  </span>
                </div>
                <p className='text'>
                  {translate('occurrences-code8.clockText')}
                </p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='section' />
                </div>

                <div
                  className='circular wrap-click'
                  onClick={() => this.handleModal(CODE8_TYPE.LMS)}
                >
                  <i className='plus' />
                </div>

                <h4 className='heading-4 uppercase title'>
                  {translate('occurrences-code8.sectionTitle')}
                </h4>
                <div>
                  <span className='highlighted-number'>
                    {code8Occurrences.totalSections}
                  </span>
                  <br />
                  <span className='subtext'>
                    {filters.dtStart || filters.dtEnd
                      ? `${filters.dtStart} - ${filters.dtEnd}`
                      : ''}
                  </span>
                </div>
                <p className='text'>
                  {translate('occurrences-code8.sectionText')}
                </p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='dollar' />
                </div>

                <div
                  className='circular wrap-click'
                  onClick={() => this.handleModal(CODE8_TYPE.SALES)}
                >
                  <i className='plus' />
                </div>

                <h4 className='heading-4 uppercase title'>
                  {translate('occurrences-code8.lossSaleTitle')}
                </h4>
                <div>
                  <span className='highlighted-number'>
                    {this.state.currency}{' '}
                    {Mask.toMoney(
                      code8Occurrences.totalLossRevenue
                        ? code8Occurrences.totalLossRevenue.toFixed(
                            this.state.sizeCurrency
                          )
                        : 0,
                      this.state.formatCurrency
                    )}
                  </span>
                  <br />
                  <span className='subtext'>
                    {filters.dtStart || filters.dtEnd
                      ? `${filters.dtStart} - ${filters.dtEnd}`
                      : ''}
                  </span>
                </div>
                <p className='text'>
                  {translate('occurrences-code8.lossSaleText')}
                </p>
              </div>
            </Col>
          </Col>
        </div>

        <Col xs={6} md={4} mdOffset={4}>
          <button
            type='button'
            onClick={getCsv}
            className='button button-primary button-full'
          >
            {translate('occurrences-code8.excelReport')}
          </button>
        </Col>

        {this.renderModal()}
      </div>
    )
  }
}

OlderOccurrencesCode8.propTypes = {
  translate: PropTypes.func.isRequired,
  code8Occurrences: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  getCsv: PropTypes.func.isRequired,
  getCsvRecurrence: PropTypes.func.isRequired,
}

export default OlderOccurrencesCode8
